import * as tslib_1 from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { RelevanceFormControl } from "@cloudpivot/form/src/common/controls/relevance-form-control";
import cloneDeep from "lodash/cloneDeep";
import { DataItemType, } from "@cloudpivot/form/schema";
import { 
// TreeSelect,
Modal, Tooltip, Icon, Spin, Input, } from "@h3/antd-vue";
// import { ReverseQueryService } from "@cloudpivot/form/src/common/services";
// import { formApi } from "@cloudpivot/api";
// import { deepCopy } from "@cloudpivot/form/utils";
import { listApi } from "@cloudpivot/api";
let RelevanceFormModal = class RelevanceFormModal extends RelevanceFormControl {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.selected = new Array();
        this.query = {};
        this.hover = false;
        this.full = false;
        this.newCol = [];
    }
    get text() {
        if (!this.ctrl.value) {
            return "";
        }
        if (!this.ctrl.value[this.getDisplayField]) {
            this.setLinkageValue();
        }
        return this.parseDisplayFieldValue(this.ctrl.value[this.getDisplayField], this.getDisplayField);
    }
    onClick() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.query = this.getParams();
            if (this.control.options.showField &&
                Array.isArray(this.control.options.showField) &&
                this.control.options.showField.length > 0) {
                let relevanceFormCode = this.control.parentKey
                    ? `${this.control.parentKey}.${this.control.key}`
                    : this.control.key;
                if (this.control.path) {
                    relevanceFormCode = this.control.path.join(".");
                }
                const param = {
                    sheetCode: this.control.options.sheetParams.sheetCode,
                    schemaCode: this.control.options.sheetParams.schemaCode,
                    relevanceFormCode: relevanceFormCode,
                };
                const res = yield listApi.selectFormTitle(param);
                if (res.errcode === 0) {
                    res.data.configBizPropertyList.map((options) => {
                        options.code = options.code === "id" ? "ids" : options.code;
                        options.propertyCode = options.code;
                        options.width = "120";
                        options.childColumns =
                            options.subSchema && options.subSchema.properties;
                        if (options.propertyType === DataItemType.Sheet &&
                            options.childColumns) {
                            options.childColumns = options.childColumns.map((v) => {
                                v.propertyCode = v.code;
                                v.vcTitle = v.name;
                                v.width = "150";
                                return v;
                            });
                        }
                        return options;
                    });
                    this.newCol = res.data.configBizPropertyList;
                    this.visible = true;
                    this.formTitleObj = yield RelevanceFormControl.service.getBizmodelTitle(this.controlOpts.schemaCode || "");
                }
            }
            else {
                this.visible = true;
            }
        });
    }
    get dialogClass() {
        // { 'full-modal': full, 'relevance-form': true }
        if (this.full) {
            return 'full-modal relevance-form';
        }
        else {
            return 'relevance-form';
        }
    }
    onMouseenter() {
        this.hover = true;
    }
    onMouseleave() {
        this.hover = false;
    }
    clear() {
        this.ctrl.value = null;
        this.selected = [];
    }
    onListChange(rows) {
        this.selected = rows;
    }
    fullScreen(full) {
        this.full = full;
    }
    onModalOk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let item = yield this.convertForMappings(this.selected[0]);
            this.visible = false;
            if (item) {
                this.interceptorValue(item);
                setTimeout(() => {
                    this.setValue(cloneDeep(item));
                }, 300);
            }
            // this.interceptorValue(item);
            // this.setValue(item);
            // setTimeout(() => {
            //   this.setValue(cloneDeep(item));
            // }, 300);
        });
    }
    onModalCancel() {
        this.visible = false;
        this.full = false;
        if (this.ctrl.value) {
            this.selected = [this.ctrl.value];
        }
        else {
            this.selected = [];
        }
    }
    get isAuthorize() {
        return this.control.options.isAuthorize;
    }
    beforeCreate() {
        const comp = RelevanceFormControl.loadListSelector();
        this.$options.components.ListSelector = comp;
    }
};
tslib_1.__decorate([
    Prop({
        default: {}
    })
], RelevanceFormModal.prototype, "control", void 0);
RelevanceFormModal = tslib_1.__decorate([
    Component({
        name: "relevance-form-modal",
        components: {
            ATooltip: Tooltip,
            AModal: Modal,
            AInput: Input,
            AIcon: Icon,
            ASpin: Spin,
        },
    })
], RelevanceFormModal);
export default RelevanceFormModal;
